import React from 'react';
import RoleListPage from '../RoleManagement/RoleListPage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './PlayerPage.module.css';

const PlayerPage: React.FC = () => (
  <RoleListPage config={ROLE_CONFIGS.player} styles={styles} />
);

export default PlayerPage;
